<template>
  <div v-if="true || $auth.check()">
    <!-- disable-resize-watcher -->
    <v-navigation-drawer
      :permanent="!is_mobile"
      floating
      :mini-variant="!drawer && !is_mobile"
      v-model="drawer"
      app
      color="white"
      class="rounded-tr-xl"
      :expand-on-hover="!drawer && !is_mobile"
      ref="the_drawer"
    >
      <!-- width="300" -->
      <v-list-item class="pl-1">
        <v-list-item :class="['pt-4 pb-4 d-flex justify-center', full_logo? '' : 'pl-0']">
          <router-link :to="{ name: 'Home' }">
            <v-img v-if="!full_logo" contain height="50" width="50" :src="z_logo"></v-img>
            <v-img v-if="full_logo" :src="logo" height="50" width="140"></v-img>
            <!-- <v-img v-if="full_logo" :src="logo_tag" height="65" width="140"></v-img> -->
          </router-link>
        </v-list-item>
        <!-- {{ $refs.the_drawer._computedWatchers.computedWidth.value > 100 }} -->
      </v-list-item>
      <v-list dense >
        <v-list-item :three-line="drawer" >
          <v-list-item-icon><v-icon>mdi-account-circle-outline</v-icon></v-list-item-icon>
          <v-list-item-content style="cursor: default" >
            <v-list-item-title class="blue-grey--text font-weight-bold">{{ profile?.name }}</v-list-item-title>
            <v-list-item-subtitle v-if="drawer">{{ profile?.email }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="drawer && profile?.roles[0]?.name != 'user'">{{ $t(`user_roles.${profile?.roles[0]?.name}`) }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="drawer">Perm.: {{ $t(`employees.roles.${profile?.employee?.roles[0]?.name}`) }}</v-list-item-subtitle>

          </v-list-item-content>
        </v-list-item>
        
      </v-list>
      <!-- <v-divider></v-divider> -->
      <v-list dense nav rounded >
        <template v-for="(link, i) in links">
          <v-list-group
            color="primary"
            v-if="link.children"
            :key="i"
            :prepend-icon="link.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(lk, idx) in link.children"
              :key="idx + lk.to"
              link
              :to="lk.to"
            >
              <v-list-item-icon>
                <v-icon>{{ lk.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ lk.text }}</v-list-item-title>
              <v-badge
                v-if="lk.has_badge"
                left
                :content="order_counter[lk.flow_status]"
                :value="order_counter[lk.flow_status]"
                color="error"
                overlap
                class="mx-3"
              ></v-badge>
            </v-list-item>
          </v-list-group>
          <v-list-item v-if="link.to" :key="i" :to="link.to" color='primary' class="blue-grey--text" active-class="primary--text font-weight-bold">
            <v-list-item-icon>
              <v-avatar
                size="24"
                color=""
                active-class="red"
              >
                <v-icon color="">{{ link.icon }}</v-icon>
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-title class="font-weight-bold">
              {{ $t(link.text) }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { drawer } from "@/router/links";
import responsive from "@/mixins/resize";
import ZLogo from "@/assets/logos/azo-z-logo.png";
import TagLogo from "@/assets/logos/azo-tag-logo.png";
import Logo from "@/assets/logos/azo-logo.png";

export default {
  name: "Drawer01",
  mixins: [responsive],
  data() {
    return {
      links: [],
      z_logo: ZLogo,
      logo: Logo,
      logo_tag: TagLogo,
    };
  },
  computed: {
    drawer: {
      get() {
        return this.$store.getters["App/getDrawer"];
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    full_logo(){
      return this.drawer || (this.$refs.the_drawer && this.$refs.the_drawer.computedWidth > 100)
    },
    ...mapState({
      profile: (state) => state.User.oneUser,
      // order_counter: (state) => state.Order.order_counter,
      // data: state=> state.Module.state_var
    }),
  },
  mounted() {
    this.setLinks();
  },
  methods: {
    setLinks() {
      // console.log('SETANDO LINKS')
      let links = []; //[...this.links]

      if (this.profile?.roles && this.$ability.rules.length) {
        const ROLE = this.profile.roles[0].name;
      
        drawer.forEach((el) => {
          if (el.permission) {

            const needs_role = el.roles && el.roles.length > 0
            const has_needed_role = (needs_role && el.roles.includes(ROLE))
            const role_evaluated = !needs_role || (needs_role && has_needed_role)
            // console.log({needs_role, has_needed_role, role_evaluated});
            
            const needs_permission = el.permission
            const has_needed_permission = this.$can(el.permission.act, el.permission.on)
            const permission_evaluated = (!needs_permission || (needs_permission && has_needed_permission))

            if ((needs_role && role_evaluated) || permission_evaluated ){
              links.push(el);
            }
          } else {
            links.push(el);
          }
        });
        this.links = [...links];
      }
    },
    ...mapMutations({
      setDrawer: "App/setDrawer",
    }),
  },
  watch: {
    profile(nv, ov) {
      if (nv) {
        this.setLinks();
      } else if (nv == false) {
      }
    },
  },
};
</script>
